import Axios from 'axios'

Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {

  post (url, data, cb) {
    Axios.post(url, data).then(
      response => {
        cb(response)
      },
      error => {
        console.error(error)
        console.error(error.response.data)
        cb(error.response)
      }
    )
  }

}
